import React from 'react';
import { Col, Card, Row, Image } from "react-bootstrap";
import PauloPfp from '../../../assets/icons/PauloPfp.svg';

const WhosWorking = () => (
    <Col className='col-6'>
        <Card className='rounded-4 shadow' style={{ backgroundColor: "#17296B", height: '100%' }}>
            <div className='m-3' style={{ height: "100%" }}>
                <Row className='border-bottom'>
                    <Col className='d-flex align-items-center gap-2 col-auto text-white'>
                        <b style={{ fontSize: "2.5vmin" }}>Quem está a trabalhar</b>
                    </Col>
                </Row>
                <div style={{ overflowY: "auto", overflowX: "hidden", height: "calc(100% - 4rem)", marginTop: "10px" }}>
                    <Row className='d-flex justify-content-center flex-column mt-2 gap-1 text-white'>
                        {['Paulo Bettencourt', 'Tomás Simas', 'Duarte Rocha', 'Diogo Qualquer Coisa', 'Tomás Duarte'].map((team, index) => (
                            <Col key={index} className='col-12 mx-2'>
                                <Image src={PauloPfp} roundedCircle style={{ width: '2vw', height: '2vw', minWidth: '20px', minHeight: '20px' }} />
                                <b className='ms-3 fw-medium' style={{ fontSize: "2vmin" }}>{team}</b>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </Card>
    </Col>
);

export default WhosWorking;
